import { render } from "./AdDocViewTransactionsAddButton.vue?vue&type=template&id=f80c4132&ts=true"
import script from "./AdDocViewTransactionsAddButton.vue?vue&type=script&lang=ts"
export * from "./AdDocViewTransactionsAddButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__